import { CheckOutlined, SearchOutlined } from '@ant-design/icons';
import { useStyles } from './styles';
import { Icon, Spin } from 'antd';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { useRef, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import SpinLoading from 'common/components/spin-loading';

const SearchAsyncSelectComponent = ({
  field,
  value: initialValue,
  list,
  onInput,
  onChange,
  onScrollEnd,
  fetching,
  isMulti,
}) => {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const [value, setValue] = useState(initialValue || []);

  const classes = useStyles({ value: initialValue });

  const handleInputChange = (selectValue, action) => {
    if (action === 'add') {
      if (isMulti) {
        setValue([...new Set(value.concat([selectValue]))]);
      } else {
        setValue([selectValue]);
      }
    } else {
      setValue(currentValue => currentValue.filter(v => v !== selectValue));
    }
  };

  const handleSearchClick = () => {
    onChange(field, value);
  };

  const handleResetClick = () => {
    if (onScrollEnd) {
      onInput('');
      setValue([]);
    } else {
      onInput();
      setValue([]);
      onChange(field, []);
    }
  };

  const handleScroll = useCallback(
    debounce(e => {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      const preOffset = 10;
      if (scrollTop + clientHeight >= scrollHeight - preOffset) {
        onScrollEnd?.();
      }
    }, 500),
    [],
  );

  const handleInput = useCallback(
    debounce(e => {
      const value = e?.target?.value;
      onInput?.(value);
    }, 500),
    [],
  );

  return (
    <div className={classes.searchWrap} ref={wrapperRef}>
      <section className={`${classes.searchBox} ${classes.showBox} `}>
        <div className={classes.inputContainer}>
          <input
            onChange={handleInput}
            placeholder={t(
              'cms:cms.global.search_component.placeholder.please_input_search_content_here',
            )}
            className={classes.searchInput}
          />
          {fetching && !list.length ? (
            <Spin
              indicator={<Icon type="loading" style={{ fontSize: 14 }} spin />}
              className={classes.searchIcon}
            />
          ) : (
            <SearchOutlined className={classes.searchIcon} />
          )}
        </div>
        <ul className={classes.listBox} onScroll={handleScroll}>
          {list?.map((option, index) => (
            <li
              onClick={() => {
                handleInputChange(option.value, value.includes(option.value) ? 'remove' : 'add');
              }}
              key={`search-${index}`}
              className={`${classes.optionList} ${
                value.includes(option.value) ? classes.activeSelected : classes.defaultColor
              }`}
            >
              {option['label']}
              {value.includes(option.value) && <CheckOutlined className={classes.optionIcon} />}
            </li>
          ))}
        </ul>
        {fetching && <SpinLoading className={classes.loading} />}
        <footer className={classes.clear}>
          <button type="button" onClick={handleResetClick}>
            {t('cms:cms.global.search_component.clear_selected')}
          </button>
          <button type="button" onClick={handleSearchClick}>
            {t('cms:cms.switch_role_page.btn.confirm')}
          </button>
        </footer>
      </section>
    </div>
  );
};

SearchAsyncSelectComponent.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  list: PropTypes.array,
};

SearchAsyncSelectComponent.defaultProps = {
  value: [],
  list: [],
};

export default SearchAsyncSelectComponent;
